import React from "react";
import { cn } from "@/utils/utils";

interface Props {
  className?: string;
}

const Skeleton: React.FC<Props> = ({ className }) => (
  <div className={cn("animate-pulse w-44 h-5", className)}>
    <div className="bg-surface-skeleton rounded w-full h-full"></div>
  </div>
);

export default Skeleton;
